import { masterApiUrl } from "API/urls/master.api";
import { axiosInstance } from "configs/axios";

export const fetchUomApi = async () => {
  try {
    const response = await axiosInstance.get(masterApiUrl.getUom);
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
